import { render, staticRenderFns } from "./SMSSettings.vue?vue&type=template&id=478cc8df"
import script from "./SMSSettings.vue?vue&type=script&lang=js"
export * from "./SMSSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports